import { Delete, Edit } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";
import moment from "moment/moment";
import { useNavigate } from "react-router";

const ReservesColumns = (reserves, eliminarOpen) => {
    const navigate = useNavigate();
    const columns = [
        {
            name: "id",
            label: "ID",
            options: {
                filter: false,
                sort: true,
                display: false,
            },
        },
        {
            name: "nom",
            label: "Nom",
            options: {
                filter: false,
                sort: true,
                sortOrder: "desc",
            },
        },
        {
            name: "cognoms",
            label: "Cognoms",
            options: {
                filter: false,
                sort: true,
                sortOrder: "desc",
            },
        },

        {
            name: "telefon",
            label: "Telèfon",
            options: {
                filter: false,
                sort: true,
                sortOrder: "desc",
            },
        },
        {
            name: "data",
            label: "Data",
            options: {
                filter: false,
                sort: true,
                sortOrder: "desc",
                customBodyRender: (value) => moment(value).format("DD/MM/YYYY"),
            },
        },

        {
            name: "activitat",
            label: "Activitat",
            options: {
                filter: false,
                sort: true,
                sortOrder: "desc",
                customBodyRender: (value) => value?.nom,
            },
        },

        {
            name: "total",
            label: "Persones",
            options: {
                filter: false,
                sort: true,
                sortOrder: "desc",
            },
        },

        {
            name: "preu",
            label: "Preu",
            options: {
                filter: false,
                sort: true,
                sortOrder: "desc",
                customBodyRender: (value) => value + "€",
            },
        },

        {
            name: "created_at",
            label: "Data creació",
            options: {
                filter: false,
                sort: true,
                sortOrder: "desc",
                customBodyRender: (value) => moment(value).format("DD/MM/YYYY HH:mm"),
            },
        },
        {
            name: "id",
            label: "Accions",
            options: {
                filter: false,
                sort: false,
                empty: true,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <Box>
                            <IconButton onClick={() => eliminarOpen(reserves[dataIndex].id)}>
                                <Delete />
                            </IconButton>
                            <IconButton
                                onClick={() =>
                                    navigate(`/admin/reserves/${reserves[dataIndex].id}`, {
                                        state: reserves[dataIndex],
                                    })
                                }
                            >
                                <Edit />
                            </IconButton>
                        </Box>
                    );
                },
            },
        },
    ];
    return columns;
};

export default ReservesColumns;
